<div *ngIf="mode === 'gridItem'" class="position-relative h-100">
    <div class="card thumb-card m-2 h-100" [class.thumb-card-expired]="media.isExpired" [title]="media.isExpired ? translate.instant('dam.expired') + media.dateValid :''  | translate">

        <!-- ===== Zone média (image + overlays) ===== -->
        <div class="thumb-media position-relative">

            <!-- Sélection (checkbox / lien déjà associé) en overlay haut-gauche -->
            <div *ngIf="selectable" class="thumb-check">
                <div *ngIf="!findMedia(linkedMedias, media.id, true); else elseBlock">
                    <label class="switch switch-sm switch-primary m-0">
                        <input type="checkbox" class="switch-input" [value]="media.id" (change)="selectedMedia($event)"
                            [checked]="findMedia(selectedMedias, media.id)" [disabled]="singleSelection && (linkedMedias.length || (selectedMedias.length && !selectedMedias.includes(media.id)) || linkAdded)"/>
                        <span class="switch-slider"></span>
                    </label>
                </div>
                <ng-template #elseBlock>
                    <i class="pi pi-link text-primary h5" [ngbTooltip]="'modal.alreadyLinked' | translate"></i>
                </ng-template>
            </div>

            <!-- Sélection panier (overlay haut-gauche) : coche pour ajouter/retirer du panier -->
            <label *ngIf="media.id && buttons?.cart && !selectable" class="thumb-check thumb-cart-check m-0"
                   [ngbTooltip]="'dam.cart' | translate" container="body">
                <input type="checkbox" [checked]="isInCart" (change)="toggleCart($event.target.checked)"/>
            </label>

            <!-- Menu kebab (actions secondaires) en overlay haut-droite -->
            <div *ngIf="media.id && hasMenuActions" ngbDropdown container="body" class="thumb-menu" placement="bottom-right">
                <button class="btn btn-sm thumb-menu-btn" ngbDropdownToggle [ngbTooltip]="'general.actions' | translate" container="body">
                    <fa-icon [icon]="faEllipsisV"></fa-icon>
                </button>
                <div ngbDropdownMenu>
                    <button *ngIf="canRename" ngbDropdownItem (click)="openRenameModal(media)">
                        <fa-icon [icon]="faEdit" class="mr-2"></fa-icon>{{ "dam.rename" | translate }}
                    </button>
                    <button *ngIf="buttons?.crop && (media.extension === 'jpg' || media.extension === 'png' || media.extension === 'jpeg')"
                            ngbDropdownItem (click)="cropMedia(media.id)">
                        <fa-icon [icon]="faCrop" class="mr-2"></fa-icon>{{ "dam.crop" | translate }}
                    </button>
                    <button *ngIf="buttons?.image" ngbDropdownItem (click)="showPopupChangeMedia(media.id)">
                        <fa-icon [icon]="faImage" class="mr-2"></fa-icon>{{ "dam.image" | translate }}
                    </button>
                    <button *ngIf="buttons?.delete" ngbDropdownItem class="text-danger" (click)="deleteMedia(media.id)">
                        <fa-icon [icon]="faTrashAlt" class="mr-2"></fa-icon>{{ "dam.delete" | translate }}
                    </button>
                    <button *ngIf="buttons?.unlink" ngbDropdownItem class="text-danger" (click)="unlinkMedia(media.id)">
                        <fa-icon [icon]="faUnlink" class="mr-2"></fa-icon>{{ "dam.unlink" | translate }}
                    </button>
                </div>
            </div>

            <!-- Badge type de fichier (sur l'image, bas-droite) -->
            <div *ngIf="media.id" class="thumb-badge rounded"
                [ngClass]="{ 'pointer': poppedUp }" (click)="selectExtension.emit({id: media.extension.toUpperCase()})">
                {{ media.extension | uppercase }}
            </div>

            <!-- Étiquette « EXPIRÉ » + ancienneté (sur l'image, bas-gauche) -->
            <div *ngIf="media.id && media.isExpired" class="thumb-expired-overlay">
                <span class="thumb-expired-badge">
                    <fa-icon [icon]="faClock" class="mr-1"></fa-icon>{{ "dam.expire" | translate | uppercase }}
                </span>
                <span class="thumb-expired-since">{{ expiredSinceLabel }}</span>
            </div>

            <!-- Image -->
            <img *ngIf="media.id && media.extension && media.extension.indexOf('mp3') > -1 && !media.thumbPath;"
                src="{{ damUrl+'/default/default-audio.jpg' }}" [id]="'img-' + media.id"
                class="thumb-img" alt="{{ media.name }}" />

            <img *ngIf="media.id && media.extension && !(media.extension.indexOf('mp3') > -1)"
                src="{{ (media.thumbPath) ? damUrl+'/'+media.thumbPath : (media.thumb ? getThumb({ binImage: media.thumb }) : damUrl+'/default/default.png') }}"
                [id]="'img-' + media.id" class="thumb-img" alt="{{ media.name }}" />

            <img *ngIf="!media.id" src="{{ media.thumbPath ? media.thumbPath : media.link ? media.link : damUrl+'/default/default.png' }}"
                [id]="'img-' + media.id" class="thumb-img" alt="{{ media.name }}" (error)="thumbnailsService.setDefaultImage($event)"/>
        </div>

        <!-- ===== Corps ===== -->
        <div class="card-body thumb-body p-2">
            <!-- Nom + date/heure de création -->
            <div class="thumb-name-row">
                <span *ngIf="media.id" class="thumb-file-icon"><span [ngClass]="getIconClass()"></span></span>
                <div class="thumb-name-block">
                    <h5 *ngIf="media.id && media.name" [ngbTooltip]="media.name" class="thumb-name text-truncate">{{ media.name | stripExtension }}</h5>
                    <h5 *ngIf="!media.id && media.link" [ngbTooltip]="media.name ? media.name : media.link" class="thumb-name text-truncate">
                        <a href="{{ media.link }}" target="_blank">{{ (media.name ? media.name : media.link) | stripExtension }}</a>
                    </h5>
                    <small *ngIf="media.id && media.dateCreate" class="thumb-datetime">{{ media.dateCreate }}</small>
                </div>
            </div>

            <ng-container *ngIf="media.id">
                <hr class="thumb-divider"/>

                <!-- Mots-clés -->
                <div class="thumb-keywords">
                    <div class="thumb-keywords-head">
                        <fa-icon [icon]="faTag" class="mr-1"></fa-icon>
                        <span class="font-weight-bold">{{ "dam.keywords" | translate }}</span>
                    </div>
                    <!-- Tags sur 2 lignes MAX. S'ils tiennent tous, ils s'affichent à
                         leur largeur naturelle. En cas de débordement, on REMPLIT les
                         2 lignes : le dernier chip d'une ligne est tronqué (max-width
                         via `tagMaxWidths`) pour caser un tag de plus, et le cluster
                         « +N autres » + « + » est réservé en fin de 2e ligne (donc
                         « +N autres » reste sur la 2e ligne, à gauche du « + »).
                         `visibleTagCount` + `tagMaxWidths` sont calculés par mesure
                         (computeVisibleTags) ; N = tags masqués (hiddenTagCount). -->
                    <div #keywordsList class="d-flex flex-row flex-wrap align-items-center mt-1 thumb-keywords-list">
                        <div *ngFor="let tag of media.tags | slice:0:visibleTagCount; index as i"
                             class="badge badge-pill badge-primary mr-1 mb-1 tags"
                             [ngStyle]="tagMaxWidths[i] ? { 'max-width.px': tagMaxWidths[i] } : null">
                            <span class="mr-1 tags-name" [title]="tag.name" [ngClass]="{ 'pointer': !minified }"
                                  (click)="tagFiltered.emit(tag)">
                                {{ tag.name }}
                            </span>
                            <span *ngIf="canAddTag" class="pointer tags-close" (click)="removeTag(media, tag.id)">x</span>
                        </div>
                        <span *ngIf="hiddenTagCount > 0"
                              class="badge badge-pill badge-light mr-1 mb-1 thumb-keywords-more"
                              container="body" [ngbTooltip]="hiddenTagCount + ' ' + (('general.others' | translate))">
                            +{{ hiddenTagCount }} {{ "general.others" | translate }}
                        </span>
                        <span *ngIf="canAddTag" (click)="openTagModal(media);"
                              class="badge badge-pill badge-primary mb-1 pointer thumb-keywords-add"
                              container="body" [ngbTooltip]="'general.addTag' | translate">
                            +
                        </span>
                    </div>
                </div>

                <hr class="thumb-divider"/>

                <!-- Dates créé / modifié -->
                <div class="thumb-dates">
                    <div class="thumb-date">
                        <fa-icon [icon]="faCalendar" class="thumb-date-icon"></fa-icon>
                        <div>
                            <small class="thumb-date-label">{{ "general.date.createdOn" | translate }}</small>
                            <small class="thumb-date-value">{{ media.dateCreate ? media.dateCreate : ("general.notAvailable" | translate) }}</small>
                        </div>
                    </div>
                    <div class="thumb-date">
                        <fa-icon [icon]="faClock" class="thumb-date-icon"></fa-icon>
                        <div>
                            <small class="thumb-date-label">{{ "general.date.updatedOn" | translate }}</small>
                            <small class="thumb-date-value">{{ media.dateUpdate ? media.dateUpdate : ("general.notAvailable" | translate) }}</small>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- ===== Footer actions principales ===== -->
        <div class="card-footer thumb-footer py-1" *ngIf="buttons">
            <!-- Mode page : sélection / crop -->
            <ng-container *ngIf="buttons?.module == 'page'">
                <button type="button" *ngIf="buttons?.select" class="btn btn-sm thumb-action" (click)="selectedMedia(media)">
                    <fa-icon [icon]="faHandPointer"></fa-icon>
                </button>
                <a type="button"
                   *ngIf="buttons?.crop && (media.extension === 'jpg' || media.extension === 'png' || media.extension === 'jpeg')"
                   class="btn btn-sm thumb-action text-warning" (click)="openCropMedia(media)">
                    <fa-icon [icon]="faCrop"></fa-icon>
                </a>
            </ng-container>

            <!-- Aperçu -->
            <button [ngbTooltip]="this.translate.instant('dam.show')" #previewTip="ngbTooltip" container="body" *ngIf="media.id && buttons?.preview"
                class="btn btn-sm thumb-action" (click)="previewTip.close(); open()">
                <fa-icon [icon]="faEye"></fa-icon>
            </button>

            <!-- Modifier (données Maestro du média) -->
            <button [ngbTooltip]="this.translate.instant('dam.edit')" container="body" *ngIf="media.id && buttons?.fill"
                class="btn btn-sm thumb-action" (click)="editMedia(media.id)">
                <fa-icon [icon]="faEdit"></fa-icon>
            </button>

            <!-- Télécharger l'original (vs téléchargement avec options dans la preview) -->
            <button [ngbTooltip]="this.translate.instant('dam.downloadOriginalAction')" container="body" *ngIf="media.id && buttons?.cart"
                class="btn btn-sm thumb-action" (click)="downloadMedia()">
                <fa-icon [icon]="faDownload"></fa-icon>
            </button>
        </div>
    </div>
</div>

<div *ngIf="mode === 'listItem'">
    <div class="row pb-1 mb-2 overflow-auto thumb-list align-items-center">
        <div class="col-5 col-md-3">
            <!-- Wrapper position-relative épousant l'image : ancre le badge au coin
                 bas-droite de la vignette (sinon right-0 déborde du padding de colonne). -->
            <div class="thumb-media position-relative">
                <div class="thumb-badge rounded">
                    {{ media.extension | uppercase }}
                </div>
                <img [src]="media.thumbPath ? damUrl+'/'+media.thumbPath : getThumb({ binImage: media.thumb })"
                     [id]="'img-' + media.id" class="thumb-img" alt="{{ media.name }}"/>
            </div>
        </div>
        <div class="col-4 col-md-6">
            <div class="thumb-name-row">
                <span class="thumb-file-icon"><span [ngClass]="getIconClass()"></span></span>
                <div class="thumb-name-block">
                    <h5 class="thumb-name text-truncate" [ngbTooltip]="media.name">{{ media.name | stripExtension }}</h5>
                    <small *ngIf="media.dateCreate" class="thumb-datetime">{{ media.dateCreate }}</small>
                </div>
            </div>
            <div class="thumb-dates mt-1">
                <div class="thumb-date">
                    <fa-icon [icon]="faCalendar" class="thumb-date-icon"></fa-icon>
                    <div>
                        <small class="thumb-date-label">{{ "general.date.createdOn" | translate }}</small>
                        <small class="thumb-date-value">{{ media.dateCreate ? media.dateCreate : ("general.notAvailable" | translate) }}</small>
                    </div>
                </div>
                <div class="thumb-date">
                    <fa-icon [icon]="faClock" class="thumb-date-icon"></fa-icon>
                    <div>
                        <small class="thumb-date-label">{{ "general.date.updatedOn" | translate }}</small>
                        <small class="thumb-date-value">{{ media.dateUpdate ? media.dateUpdate : ("general.notAvailable" | translate) }}</small>
                    </div>
                </div>
            </div>
            <div class="tags mt-1 flex-wrap">
                <span *ngFor="let tag of media.tags | slice:0:6" class="badge badge-pill badge-primary mr-1 mb-1">
                    <span class="mr-1" [ngClass]="{ 'pointer': !minified }" (click)="tagFiltered.emit(tag)">{{ tag.name }}</span>
                    <span *ngIf="canAddTag" class="pointer" (click)="removeTag(media, tag.id)">x</span>
                </span>
                <span *ngIf="media.tags && media.tags.length > 6" class="badge badge-pill badge-light mr-1 mb-1">
                    +{{ media.tags.length - 6 }} {{ "general.others" | translate }}
                </span>
                <span *ngIf="canAddTag" (click)="openTagModal(media);"
                      class="badge badge-pill badge-primary mb-1 pointer"
                      container="body" [ngbTooltip]="'general.addTag' | translate">+</span>
            </div>
        </div>
        <div class="col thumb-list-actions">
            <button [ngbTooltip]="this.translate.instant('dam.show')" #previewTipList="ngbTooltip" placement="bottom" *ngIf="buttons?.preview"
                    class="btn btn-primary mt-1 mr-2" (click)="previewTipList.close(); open()">
                <fa-icon [icon]="faEye"></fa-icon>
            </button>
            <button [ngbTooltip]="this.translate.instant('dam.downloadOriginalAction')" placement="bottom" *ngIf="media.id && buttons?.cart"
                    class="btn btn-primary mt-1 mr-2" (click)="downloadMedia()">
                <fa-icon [icon]="faDownload"></fa-icon>
            </button>
            <button [ngbTooltip]="this.translate.instant('dam.cart')" placement="bottom" *ngIf="buttons?.cart"
                    class="btn btn-primary mt-1 mr-2" (click)="addCart.emit(media)">
                <fa-icon [icon]="faBucket"></fa-icon>
            </button>
            <button [ngbTooltip]="this.translate.instant('dam.image')" placement="bottom" *ngIf="buttons?.image"
                    class="btn btn-primary mt-1 mr-2" (click)="showPopupChangeMedia(media.id)">
                <fa-icon [icon]="faImage"></fa-icon>
            </button>
            <button [ngbTooltip]="this.translate.instant('dam.crop')" placement="bottom"
                    *ngIf="buttons?.crop && (media.extension === 'jpg' || media.extension === 'png' || media.extension === 'jpeg')"
                    class="btn btn-primary mt-1 mr-2" (click)="cropMedia(media.id)">
                <fa-icon [icon]="faCrop"></fa-icon>
            </button>
            <button [ngbTooltip]="this.translate.instant('dam.edit')" placement="bottom"
                    *ngIf="buttons?.fill && media.model" class="btn btn-primary mt-1 mr-2" (click)="editMedia(media.id)">
                <fa-icon [icon]="faEdit"></fa-icon>
            </button>
            <button [ngbTooltip]="this.translate.instant('dam.delete')" placement="bottom" *ngIf="buttons?.delete"
                    class="btn btn-danger mt-1 mr-2" (click)="deleteMedia(media.id)">
                <fa-icon [icon]="faTrashAlt"></fa-icon>
            </button>
            <button [ngbTooltip]="this.translate.instant('dam.unlink')" placement="bottom" *ngIf="buttons?.unlink"
                    class="btn btn-danger mt-1 mr-2" (click)="unlinkMedia(media.id)">
                <fa-icon [icon]="faUnlink"></fa-icon>
            </button>
        </div>
    </div>
</div>

<swal #changeMedia title="{{ 'modal.updateMedia' | translate }}" confirmButtonText="{{ 'modal.upload' | translate }}">
    <div *swalPortal>
        <input class="form-control" id="newFile" type="file" accept="{{ acceptList }}">
        <div class="mx-1 mt-3" *ngIf="acl.MAESTRO_DAM_PICTO_CREATE === 1">
            <table>
                <tr>
                    <td>
                        <label class="font-weight-bold">{{ "upload.picto" | translate }}</label>
                    </td>
                    <td class="pt-1 pl-2">
                        <label class="switch switch-pill switch-primary">
                            <input id="picto" type="checkbox" class="switch-input">
                            <span class="switch-slider"></span>
                        </label>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</swal>

<swal #addTagModal title="TBD" confirmButtonText="{{ 'modal.add' | translate }}">
    <div *swalPortal>
        <form [formGroup]="formAddTag">
            <app-drop-down [type]="'multi'" [list]="filteredTags" formControlName="tag"></app-drop-down>
        </form>
    </div>
</swal>

<swal #renameModal title="{{ 'dam.rename' | translate }}" confirmButtonText="{{ 'general.save' | translate }}" [showCancelButton]="true" cancelButtonText="{{ 'general.cancel' | translate }}">
    <div *swalPortal>
        <form [formGroup]="formRename">
            <input class="form-control" type="text" formControlName="name" placeholder="{{ 'dam.renamePlaceholder' | translate }}"/>
        </form>
    </div>
</swal>

<!-- Formulaire d'édition du média en pop-up (réutilise app-edit-form en mode preview),
     ouvert depuis la liste à la place de la navigation vers la page dédiée. -->
<ng-template #editFormModal let-modal>
    <div class="modal-header align-items-center">
        <ng-container *ngIf="!editingName; else editFormNameEdit">
            <h4 class="modal-title text-truncate mb-0 mr-2">{{ media.name }}</h4>
            <button *ngIf="canRename" type="button" class="btn btn-sm btn-link text-primary p-0 mr-auto" (click)="editingName = true" container="body" placement="bottom" [ngbTooltip]="'dam.rename' | translate">
                <fa-icon [icon]="faPen"></fa-icon>
            </button>
        </ng-container>
        <ng-template #editFormNameEdit>
            <div class="d-flex align-items-center flex-grow-1 mr-2" style="min-width: 0;">
                <input #editFormNameInput type="text" class="form-control form-control-sm" [value]="nameBase" (keyup.enter)="saveName(editFormNameInput.value)"/>
                <button type="button" class="btn btn-sm btn-primary ml-1" (click)="saveName(editFormNameInput.value)">{{ 'general.save' | translate }}</button>
                <button type="button" class="btn btn-sm btn-secondary ml-1" (click)="editingName = false">{{ 'general.cancel' | translate }}</button>
            </div>
        </ng-template>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0">
        <app-edit-form [preview]="true" [mediaId]="media.id"></app-edit-form>
    </div>
</ng-template>

<app-cropper #cropper [defaultRatio]="true" (cropped)="croppedMedia($event)"></app-cropper>

<swal #datamodel title="{{ 'modal.datamodel' | translate }}" confirmButtonText="{{ 'modal.confirm' | translate }}">
    <div *swalPortal>
        <span *ngIf="media.model" class="text-danger font-weight-bold">{{
                "modal.mediadam.updateDm" | translate
            }}</span>
        <form class="mt-2" [formGroup]="dataModelForm">
            <app-drop-down [type]="'single'" [list]="dataModels" formControlName="dm"></app-drop-down>
        </form>
    </div>
</swal>
